type ToastMessageType = 'default' | 'info' | 'success' | 'error' | 'warning';

interface ToastMessageProps {
	hasCloseButton?: boolean;
	type?: ToastMessageType;
}

const TOAST_MESSAGE_DEFAULT_PROPS = {
	hasCloseButton: true,
	type: 'default',
} satisfies Required<ToastMessageProps>;

export {
	TOAST_MESSAGE_DEFAULT_PROPS,
	type ToastMessageProps,
	type ToastMessageType,
};
